import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Button } from '~/chords/Button';
import { ModalDialog } from '~/components/ModalDialog/ModalDialog';

import { ChatPrompter } from './components/ChatPrompter';
import { MessageList } from './components/MessageList';
import { useMusicIqChatbot } from './hooks/useMusicIqChatbot';

export function ChatbotPage() {
  const { t } = useTranslation('data');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { messages, ask, abort, isThinking, error } = useMusicIqChatbot();

  const onSubmit = async (question: string) => {
    if (!question || isThinking) {
      return;
    }

    await ask(question);
  };

  // @TODO WMG1-908 - Handle question selection.
  // const handleQuestionSelected = (question: string) => {
  //   // eslint-disable-next-line no-console
  //   console.log('Selected question:', question);
  // };

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-lg bg-[linear-gradient(175deg,#2B2D1B_0%,#121C2D_41%)] p-2xl">
      <Helmet>
        <title>{t('musicIq.pageTitle')}</title>
      </Helmet>

      <div className="flex h-full w-[483px] flex-col justify-between gap-lg">
        <MessageList messages={messages} isThinking={isThinking} />

        {error ? (
          <div className="px-lg py-sm text-body-sm text-error-default">
            {t('musicIq.chatbot.error')} {error?.message}
          </div>
        ) : null}

        <div className="space-y-4xl">
          {/* @TODO WMG1-908 - Refactor to get the default questions displayed on first load. */}
          {/* <DefaultQuestions onQuestionSelected={handleQuestionSelected} /> */}
          <ChatPrompter
            isLoading={isThinking}
            onSubmit={onSubmit}
            onStop={abort}
            onOpenModalClick={() => setIsModalOpen(true)}
          />
        </div>

        <ModalDialog open={isModalOpen} onOpenChange={setIsModalOpen}>
          <ModalDialog.Header>
            {t('musicIq.chatPrompter.modal.title')}
          </ModalDialog.Header>
          <ModalDialog.Body className="flex flex-col gap-md text-body-sm text-default">
            <p>{t('musicIq.chatPrompter.modal.body')}</p>
            <p>{t('musicIq.chatPrompter.modal.bodySecondary')}</p>
          </ModalDialog.Body>
          <ModalDialog.Footer>
            <ModalDialog.Close>
              <Button variant="primary">
                {t('musicIq.chatPrompter.modal.ok')}
              </Button>
            </ModalDialog.Close>
          </ModalDialog.Footer>
        </ModalDialog>
      </div>
    </div>
  );
}

ChatbotPage.displayName = 'ChatbotPage';
